import { render, staticRenderFns } from "./GraphDetail53.vue?vue&type=template&id=4c63dac3&scoped=true&"
import script from "./GraphDetail53.vue?vue&type=script&lang=js&"
export * from "./GraphDetail53.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c63dac3",
  null
  
)

export default component.exports